import { render } from "./ZyxelFooter.vue?vue&type=template&id=661d7b8e"
import script from "./ZyxelFooter.vue?vue&type=script&lang=js"
export * from "./ZyxelFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__